<template>
  <div class="verify-log">
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true" :model="searchForm" @submit.native.prevent="handleSearch">
        <el-form-item label="关键词">
          <el-input
              v-model="searchForm.keyword"
              placeholder="订单号/商品名"
              clearable
              style="width: 200px"
              @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>

        <el-form-item label="领取人">
          <el-input
              v-model="searchForm.realName"
              placeholder="领取人"
              clearable
              style="width: 100px"
              @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>

        <el-form-item label="核销码">
          <el-input
              v-model="searchForm.verifyCode"
              placeholder="核销码"
              clearable
              style="width: 120px"
              @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          <el-button
              type="warning"
              icon="el-icon-finished"
              :loading="generating"
              @click="handleGenerate"
          >生成文件</el-button>
          <el-button
              type="success"
              icon="el-icon-download"
              :loading="exportLoading"
              @click="handleExport"
          >导出核销记录</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="hover" class="table-card">
      <el-table :data="tableData" v-loading="loading" stripe border>
        <el-table-column prop="orderNo" label="订单号" width="180"></el-table-column>
        <el-table-column prop="realName" label="领取人" width="100"></el-table-column>
        <el-table-column prop="personType" label="类型" width="110" align="center"></el-table-column>
        <el-table-column prop="verifyCode" label="核销码" width="110" align="center"></el-table-column>
<!--        <el-table-column label="类型" width="110">-->
<!--          <template slot-scope="{ row }">-->
<!--            <el-tag :type="personTypeTagType(row.personType)" size="small">-->
<!--              {{ row.personType || '-' }}-->
<!--            </el-tag>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="communityName" label="所属社区" width="100"></el-table-column>-->
<!--        <el-table-column prop="productName" label="商品名称" min-width="100"></el-table-column>-->
<!--        <el-table-column label="商品类型" width="90" align="center">-->
<!--          <template slot-scope="{ row }">-->
<!--            <el-tag size="small" :type="row.ownerType === 1 ? 'success' : 'warning'">-->
<!--              {{ row.ownerType === 1 ? '社区' : '商户' }}-->
<!--            </el-tag>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="ownerName" label="商品所属门店" min-width="140"></el-table-column>
        <el-table-column prop="verifyTime" label="核销时间" width="160" > </el-table-column>
      </el-table>

      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          class="pagination"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import {getOrderList,getOrderAllList,downloadDailyExport,generateExportFile} from '@/api/order'

import {getPersonTypeList} from "@/api/user";


export default {
  name: 'VerifyLog',
  data() {
    return {
      searchForm: { claimStatus: 1, keyword: '', realName: '', verifyCode: '' },
      tableData: [],
      loading: false,
      exportLoading: false,
      page: 1,
      size: 10,
      total: 0,
      currentRow: null,
      submitting: false,
      personTypeOptions: [],
      // label -> tagType，供表格 tag 取色
      personTypeMap: {},

      generating: false,

    }
  },
  mounted() { this.loadData();this.loadPersonTypes()},
  methods: {
    async loadPersonTypes() {
      try {
        const res = await getPersonTypeList()
        // 兼容 R<T> 包装与裸数组两种返回结构
        const raw = res && res.data != null ? res.data : res
        const list = (raw && (raw.records || raw.list || raw.items)) || raw || []
        if (!Array.isArray(list) || !list.length) {
          throw new Error('empty')
        }
        // 后端 sort 可能缺省，按数组下标兜底，保证展示顺序稳定
        const sorted = [...list].sort(
            (a, b) => (a.sort == null ? 0 : a.sort) - (b.sort == null ? 0 : b.sort)
        )
        this.personTypeOptions = sorted
            .filter(i => i && i.label)
            .map(i => ({ label: i.label, value: i.label, code: i.code }))
        this.personTypeMap = sorted.reduce((m, i) => {
          if (i && i.label) m[i.label] = i.tagType || ''
          return m
        }, {})
      } catch (e) {
        // 接口异常时降级，避免下拉框为空导致无法编辑
        this.personTypeOptions = FALLBACK_PERSON_TYPES.map(i => ({
          label: i.label,
          value: i.label,
          code: i.code
        }))
        this.personTypeMap = FALLBACK_PERSON_TYPES.reduce((m, i) => {
          m[i.label] = i.tagType
          return m
        }, {})
      }
    },
    // ===== 列表加载（保持不变）=====
    async loadData() {
      this.loading = true
      try {
        const res = await getOrderList(this.searchForm.claimStatus, this.searchForm.keyword, this.searchForm.realName, this.searchForm.verifyCode,this.page, this.size)

        const list = res.records || res.list || res.items || res || []
        this.tableData = Array.isArray(list) ? list : []
        this.total = res.total || this.tableData.length

      } catch (e) {
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },


    async handleGenerate() {
      if (this.generating) return
      this.generating = true
      try {
        // 生成今天的文件，传 date 可指定其他日期
        const res = await generateExportFile()
        const data = res && res.data ? res.data : res
        // 后端返回结构可能为 { code, msg, data } 或直接是 data，按你项目封装自行调整
        this.$message.success((data && data.msg) || '文件已生成')
      } catch (e) {
        console.error(e)
        this.$message.error((e && e.msg) || '生成失败')
      } finally {
        this.generating = false
      }
    },

    async handleExport() {
      if (this.exportLoading) return
      this.exportLoading = true
      try {
        const blob = await downloadDailyExport()

        // ✅ 后端抛 BusinessException 时返回的是 JSON，不是 xlsx，需识别出来
        if (blob && blob.type && blob.type.indexOf('application/json') !== -1) {
          const text = await this.blobToText(blob)
          let msg = '导出文件尚未生成'
          try {
            const err = JSON.parse(text)
            msg = err.msg || err.message || msg
          } catch (e) { /* 非 JSON 文本，用默认提示 */ }
          throw new Error(msg)
        }

        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `核销记录_${this.formatFileTime(new Date())}.xlsx`
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        setTimeout(() => URL.revokeObjectURL(url), 0)

        this.$message.success('导出成功')
      } catch (e) {
        console.error(e)
        this.$message.error(e.message || '导出失败')
      } finally {
        this.exportLoading = false
      }
    },

    /** Blob 转文本（兼容不支持 blob.text() 的浏览器） */
    blobToText(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsText(blob, 'utf-8')
      })
    },

    // ===== 导出：循环拉取所有页 =====
    // async handleExport() {
    //   if (this.exportLoading) return
    //   this.exportLoading = true
    //   this.$message.info('正在获取数据，请稍候...')
    //
    //   try {
    //     const allRows = await this.fetchAllPages()
    //     if (!allRows.length) {
    //       this.$message.warning('没有可导出的数据')
    //       return
    //     }
    //     await this.exportToExcel(allRows)
    //     this.$message.success(`导出成功，共 ${allRows.length} 条`)
    //   } catch (e) {
    //     console.error(e)
    //     this.$message.error(e.message || '导出失败')
    //   } finally {
    //     this.exportLoading = false
    //   }
    // },

    // 循环拉取全部页
    async fetchAllPages() {
      const { keyword,realName,verifyCode } = this.searchForm
      let all = []

      const res = await getOrderAllList(1, keyword,realName,verifyCode)
      const list = res.records || res.list || res.items || res || []
      const rows = Array.isArray(list) ? list : []

      all = all.concat(rows)
      return all
    },

    // 生成并下载 Excel
    async exportToExcel(rows) {
      const XLSX = await import('xlsx') // 按需加载

      const { keyword,realName,verifyCode } = this.searchForm
      // 表头（中文）
      const header = ['订单号', '核销码', '领取人','所属门店', '核销时间']
      // 数据行，字段顺序与表头一一对应
      const body = rows.map(r => [
        r.orderNo,
        r.verifyCode,
        r.realName,
        r.personType,
        r.ownerName,
        r.verifyTime,
      ])

      const ws = XLSX.utils.aoa_to_sheet([header, ...body])
      // 列宽
      ws['!cols'] = [
        { wch: 22 },  // 订单号
        { wch: 14 },  // 核销码
        { wch: 10 },  // 领取人
        { wch: 12 },  // 类型
        { wch: 12 },  // 所属门店
        { wch: 20 },  // 核销时间
      ]

      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '核销记录')

      // ✅ 用 array 输出，自己构造 Blob，明确 MIME 类型
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })

      const blob = new Blob([wbout], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })

      const ts = this.formatFileTime(new Date())
      const fileName = `核销记录_${ts}.xlsx`

      // ✅ 用 a 标签下载，移动端兼容性更好
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      setTimeout(() => URL.revokeObjectURL(url), 0)
    },

    handleSearch() { this.page = 1; this.loadData() },
    resetSearch() { this.searchForm = { claimStatus: 1, keyword: '', realName: '',verifyCode:'' }; this.page = 1; this.loadData() },
    handleSizeChange(val) { this.size = val; this.loadData() },
    handleCurrentChange(val) { this.page = val; this.loadData() },
    statusType(s) {
      const map = { 0: 'warning', 1: 'success', 2: 'info', 3: 'danger' }
      return map[s] || ''
    },
    statusText(s) {
      const map = { 0: '待领取', 1: '已核销', 2: '已取消', 3: '已过期' }
      return map[s] || '-'
    },
    personTypeTagType(type) {
      if (!type) return ''
      return this.personTypeMap[type] || ''
    },
    formatTime(t) { return t ? new Date(t).toLocaleString('zh-CN', { hour12: false }) : '-' },
    formatFileTime(d) {
      const p = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}_${p(d.getHours())}${p(d.getMinutes())}`
    }
  }
}
</script>

<style scoped>
.verify-log { padding: 0; }
.search-card { margin-bottom: 16px; border-radius: 8px; }
.table-card { border-radius: 8px; }
.pagination { margin-top: 16px; text-align: right; }
</style>